import { AuthAccount2, AuthOrganization } from "../../graphql/types"
import { OrganizationData } from "./types"

export const transformAuthOrganizationData = (
    authOrganizations: AuthOrganization[],
    authAccounts: AuthAccount2[]
): OrganizationData[] =>
    authOrganizations.map(o => ({
        ...o,
        accounts: authAccounts.filter(a => a.organizationId === o.id),
    }))
